
import { mapGetters } from "vuex";
import Magnify from "vue-material-design-icons/Magnify.vue";

export default {
  name: "EstoqueGrupoProduto",
  components: {
    Magnify,
  },
  props: {
    produto: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      carregando: false,
      erroConsulta: "",
      consulta: null,
      empresaPesquisa: null,
      termoPesquisa: "",
      resultados: [],
      pesquisando: false,
      pesquisaExecutada: false,
      vinculando: null,
    };
  },
  computed: {
    ...mapGetters(["empresaContexto", "empresas"]),
    empresasDoGrupo() {
      const grupoId = Number(this.empresaContexto?.id_grupo_empresa || 0);

      return (this.empresas || []).filter(
        (empresa) => Number(empresa.id_grupo_empresa || 0) === grupoId
      );
    },
    podeConsultar() {
      return (
        Number(this.produto?.id || 0) > 0 &&
        !this.produto?.isKit &&
        Number(this.empresaContexto?.id_grupo_empresa || 0) > 0 &&
        this.empresasDoGrupo.length > 1
      );
    },
  },
  watch: {
    "produto.id"() {
      this.consulta = null;
      this.erroConsulta = "";
      this.limparPesquisa();
    },
  },
  mounted() {
    window.addEventListener("keydown", this.abrirPeloAtalho);
  },
  beforeDestroy() {
    window.removeEventListener("keydown", this.abrirPeloAtalho);
  },
  methods: {
    abrirPeloAtalho(event) {
      if (event.key !== "F9" || event.repeat || !this.podeConsultar) return;

      event.preventDefault();
      event.stopPropagation();
      this.abrir();
    },
    async abrir() {
      this.$refs.modal.show();
      await this.consultar();
    },
    async consultar() {
      this.carregando = true;
      this.erroConsulta = "";

      try {
        const response = await this.$http.post("/empresa/grupo/estoques/produto", {
          id_produto: Number(this.produto.id),
        });
        this.consulta = response.data.data;
      } catch (error) {
        this.consulta = null;
        this.erroConsulta =
          error?.response?.data?.message ||
          "Não foi possível consultar os estoques agora.";
      } finally {
        this.carregando = false;
      }
    },
    iniciarPesquisa(item) {
      this.empresaPesquisa = item;
      this.termoPesquisa = this.produto?.referencia || this.produto?.cod_barras || "";
      this.resultados = [];
      this.pesquisaExecutada = false;
    },
    limparPesquisa() {
      this.empresaPesquisa = null;
      this.termoPesquisa = "";
      this.resultados = [];
      this.pesquisaExecutada = false;
      this.pesquisando = false;
    },
    async pesquisar() {
      if (!this.empresaPesquisa || this.termoPesquisa.length < 2 || this.pesquisando) {
        return;
      }

      this.pesquisando = true;

      try {
        const response = await this.$http.post("/empresa/grupo/estoques/pesquisar", {
          id_produto_origem: Number(this.produto.id),
          id_empresa_destino: Number(this.empresaPesquisa.empresa.id_empresa),
          busca: this.termoPesquisa,
        });
        this.resultados = response.data.data || [];
        this.pesquisaExecutada = true;
      } finally {
        this.pesquisando = false;
      }
    },
    async vincular(produtoDestino) {
      if (!this.empresaPesquisa || this.vinculando) return;

      this.vinculando = produtoDestino.id;

      try {
        const response = await this.$http.post("/empresa/grupo/estoques/vincular", {
          id_produto_origem: Number(this.produto.id),
          id_empresa_destino: Number(this.empresaPesquisa.empresa.id_empresa),
          id_produto_destino: Number(produtoDestino.id),
        });
        this.consulta = response.data.data;
        this.limparPesquisa();

        if (this.$toast) {
          this.$toast.success("Produto vinculado à empresa com sucesso.");
        }
      } finally {
        this.vinculando = null;
      }
    },
    textoStatus(item) {
      const textos = {
        ORIGEM: "Empresa atual",
        VINCULADO: "Vínculo manual",
        LOCALIZADO:
          item.metodo === "COD_BARRAS" ? "Mesmo código de barras" : "Mesma referência",
        AMBIGUO: "Mais de um resultado",
        NAO_LOCALIZADO: "Não localizado",
      };

      return textos[item.status] || item.status;
    },
    classeStatus(status) {
      if (["ORIGEM", "VINCULADO"].includes(status)) return "label-light-primary";
      if (status === "LOCALIZADO") return "label-light-success";
      if (["AMBIGUO", "NAO_LOCALIZADO"].includes(status)) return "label-warning";
      return "label-light-secondary";
    },
    classeDisponivel(produto) {
      if (!produto) return "";
      return Number(produto.disponivel) > 0 ? "text-success" : "text-danger";
    },
    formatarQuantidade(valor) {
      return Number(valor || 0).toLocaleString("pt-BR", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 3,
      });
    },
  },
};
